export interface Vacancy {
  id: number;
  job_title: string;
  job_description: string;
  job_type: string;
  job_site: string;
  experience_level: string;
  education: string;
  gender_preference: string;
  vacancies: number;
  deadline: string;
  date_posted: string;
  created_at: string;
  updated_at: string;
}

export interface VacancyFormData {
  job_title: string;
  job_description: string;
  job_type: string;
  job_site: string;
  experience_level: string;
  education: string;
  gender_preference: string;
  vacancies: number;
  deadline: string;
}

export const JOB_TYPES = [
  'Full Time',
  'Part Time',
  'Freelance',
  'Contractual',
  'Volunteer',
  'Paid Intern'
];

export const JOB_SITES = [
  'On Site',
  'Remote',
  'Hybrid'
];

export const EXPERIENCE_LEVELS = [
  'Entry',
  'Junior',
  'Intermediate',
  'Senior',
  'Expert'
];

export const EDUCATION_LEVELS = [
  'TVET',
  'Secondary School',
  'Certificate',
  'Diploma',
  'Bachelors Degree',
  'PhD'
];

export const GENDER_PREFERENCES = [
  'Male',
  'Female',
  'Any'
];
